"use client"

import { useTranslations } from "next-intl"
import { useSourceStore } from "@/lib/source-store"
import { SOURCE_FILTER_ROW, sourceFilterPill } from "@/components/source-filter-pill"

/**
 * 4chan board picker. Nothing is chosen by default ("None": 4chan adds nothing to the grid), and one board at a time can be picked, so a
 * search never pulls threads from a dozen boards at once. Clicking the picked board again goes back to None.
 */
export function FourchanBoardTabs() {
  const tbn = useTranslations("boardNames")
  const source = useSourceStore((state) => state.getSource("4chan"))
  const updateSource = useSourceStore((state) => state.updateSource)

  if (!source?.boards) return null

  const { available, selected } = source.boards
  const active = selected.length === 1 ? selected[0] : null
  const choose = (board: string | null) => updateSource("4chan", { boards: { ...source.boards!, selected: board ? [board] : [] } })

  return (
    <div className={SOURCE_FILTER_ROW}>
      <button onClick={() => choose(null)} className={sourceFilterPill(active === null)}>
        {tbn("fourchan_none")}
      </button>
      {available.map((board) => (
        <button
          key={board.id}
          title={board.name}
          onClick={() => choose(active === board.id ? null : board.id)}
          className={sourceFilterPill(active === board.id)}
        >
          /{board.id}/
        </button>
      ))}
    </div>
  )
}
